import React from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../styles/Common/Breadcrump.css";

const Breadcrumb = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const pathnames = location.pathname.split("/").filter((x) => x);

  const handleBack = () => {
    if (location.pathname.includes('/product-description')) {
      navigate('/skills', { replace: true });
    } else if (location.pathname.startsWith('/skills/') && location.pathname !== '/skills') {
      // Check if it's a hardcoded route
      const hardcodedRoutes = ['/skills/email', '/skills/blog', '/skills/chat', 
                                '/skills/product-description', '/skills/free-form-content'];
      const isHardcodedRoute = hardcodedRoutes.some(route => 
        location.pathname === route || location.pathname.startsWith(route + '/')
      );
      
      if (!isHardcodedRoute) {
        // It's a DIY agent route, go back to skills page
        navigate('/skills', { replace: true });
      } else {
        navigate(-1);
      }
    } else {
      navigate(-1);
    }
  };

  return (
    <div className="breadcrumb-container mx-3">
      {/* Back Button */}
      <div className="breadcrumb-back" onClick={handleBack}>
        <span className="back-text">{'<'} Back</span>
      </div>

      {/* Breadcrumb */}
      <nav aria-label="breadcrumb">
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          {pathnames.map((value, index) => {
            const url = `/${pathnames.slice(0, index + 1).join("/")}`;
            const isLast = index === pathnames.length - 1;

            return (
              <React.Fragment key={url}>
                <span className="breadcrumb-separator"> &gt; </span>
                <li className={`breadcrumb-item ${isLast ? "active" : ""}`}>
                  {isLast ? (
                    <span>
                      {value.replace(/-/g, " ").charAt(0).toUpperCase() +
                        value.replace(/-/g, " ").slice(1)}
                    </span>
                  ) : (
                    <Link to={url}>
                      {value.replace(/-/g, " ").charAt(0).toUpperCase() +
                        value.replace(/-/g, " ").slice(1)}
                    </Link>
                  )}
                </li>
              </React.Fragment>
            );
          })}
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
